// extracted by mini-css-extract-plugin
export default {"subheading":"beam-modal_subheading__gMAb6","closeIcon":"beam-modal_closeIcon__NXPrJ"};